import { memo } from 'react';
import { t } from 'i18next';
import { Stack } from '@mui/system';
import { Divider } from '@mui/material';
import { Accordion } from '@common/components/Accordion';
import { useReadSelectedObstacles } from '@/modules/floorplanDesign/hooks/useReadSelectedObstacles';

import { Thickness } from './obstacle/Thickness';
import WallMaterial from './obstacle/WallMaterial';
import Height from './obstacle/Height';
import { SegmentDimensions } from './SegmentDimensions';

function WallParametersComponent() {
  const selectedObstacles = useReadSelectedObstacles();
  const selectedObstacle =
    selectedObstacles.length === 1 ? selectedObstacles[0] : null;

  if (!selectedObstacle) return null;

  return (
    <Stack spacing={1} divider={<Divider />}>
      <SegmentDimensions mode='wall' />
      <Accordion
        title={t<string>('interface:properties.wall.wall_title', 'Wall')}
        unmountOnExit
        defaultExpanded
        sx={{ px: 2 }}
      >
        <Stack direction='column' spacing={1} pb={2}>
          <Thickness selectedWall={selectedObstacle} />
          <WallMaterial />
          <Height />
        </Stack>
      </Accordion>
    </Stack>
  );
}

export const WallParameters = memo(WallParametersComponent);
